<h2 mat-dialog-title>
  Update Complaints Status <br>
  <small style="font-weight:10px; font-size: 14px; padding-left: 5px;">Review the complaints and update its status,or
    escalate if needed.</small>
  <button mat-icon-button (click)="onClose()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content mt-3">
  <form [formGroup]="complaintForm">
    <mat-label>Update Status<span style="color: red;">*</span></mat-label>
    <mat-form-field appearance="outline" class="full-width" style="width: 100%;">
      <mat-select formControlName="status" name="status" required>
        <mat-option value="RESOLVED" *ngIf="updatedata['status']=='PENDING'">RESOLVED</mat-option>
        <mat-option value="CLOSED" *ngIf="updatedata['status']=='RESOLVED'">CLOSED</mat-option>
      </mat-select>
    </mat-form-field>

    <br />

    <mat-label>Remarks/Action Taken<span style="color: red;">*</span></mat-label>
    <mat-form-field appearance="outline" class="full-width" style="width: 100%;">
      <textarea matInput rows="4" formControlName="remarks" name="remarks" required></textarea>
    </mat-form-field>

    <br />

    <mat-label>Upload Supporting Document (optional)</mat-label>
    <!-- <mat-form-field appearance="outline" class="full-width" style="width: 100%;" (click)="fileInput.click()">
      <input matInput [value]="uploadedFileName" readonly />
      <button mat-icon-button matSuffix aria-label="Upload file">
        <mat-icon>upload</mat-icon>
      </button>
      <input type="file" #fileInput style="display: none" />
    </mat-form-field> -->
                  <input #resolvedDocInput type="file" formControlName="doc_name"  id="mapFileInput" accept="application/pdf" (change)="checkFile($event,'')" style="margin-top: 5px;"  #fileInputl name="invoiceFile"   class="upload-box form-control"  />
                <p (click)="view('')" class="text-right text-primary" style="text-decoration: underline; cursor: pointer;" *ngIf="selectedFileUrlObj['resolved']   || selectedFileUrlObj['closed'] ">click here to view </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-raised-button style="background-color: #226CE0; color: white;" (click)="submit()">Update
    Complaint</button>
</mat-dialog-actions>